import * as Types from '../constants/ActionTypes';

import IReducerAction from '../interfaces/ReducerAction';

const initialState = {
  councils: [],
};

const selectables = (state = initialState, action: IReducerAction) => {
  switch(action.type) {
    case Types.SET_COUNCILS:
      return { ...state, councils: action.payload.councils };
    default:
      return state;
  }
};

export default selectables;



// WEBPACK FOOTER //
// ./src/reducers/selected.ts